// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import formatQuickAddSiteForApi from './formatQuickAddSiteForApi'
import { getDefaultRadioServiceIdForProject } from 'redux/modules/pathDetails'

// d is the formData from the quick add redux-form

const formatQuickAddDataForApi = d => (dispatch, getState) => {
  const projectId = getState().projectSummary.get('projectId')

  // get the 'default radioServiceId' for the project and
  // use it if there are no radioServiceIds assigned to the Quick Add Sites' data.
  const projectDefaultRadioServiceId = dispatch(getDefaultRadioServiceIdForProject())

  const bandId = castToFloat(d.band)
  const pathName = d.pathName?.trim() || null

  const site1 = formatQuickAddSiteForApi(d.sites[0], projectDefaultRadioServiceId)
  const site2 = formatQuickAddSiteForApi(d.sites[1], projectDefaultRadioServiceId)

  return {
    bandId,
    pathName,
    projectId,
    segments: [{
      segmentEnds: [
        site1,
        site2,
      ],
    }],
  }
}

export default formatQuickAddDataForApi
